._ProgramDetails_1wybf_1 ._menu_1wybf_1 {
  margin-bottom: 20px;
}